// extracted by mini-css-extract-plugin
module.exports = {"button":"idt-orderbutton_button__34jdj","loading":"idt-orderbutton_loading__3ytyr","spinner":"idt-orderbutton_spinner__3vlei"};